import React,{Component,Fragment} from 'react';
import PropTypes from 'prop-types';

const LEFT_PAGE='LEFT';
const RIGHT_PAGE='RIGHT';

/** Helper method for creating a range of numbers */

const range=(from,to,step=1)=>{
  let i=from;
  const range=[];
  while(i<=to){
    range.push(i);
    i+=step;
  }
  return range;
}

class Pagination extends Component{
  
  constructor(props){
    super(props);
    let {totalRecords=null,pageLimit=30,pageNeighbours=0}=props;

    pageLimit=typeof pageLimit==='number'?pageLimit:30;
    totalRecords=typeof totalRecords ==='number'?totalRecords:0;  
    
    //vecini pagina pot fi: 0,1 sau 2
    pageNeighbours=typeof pageNeighbours==='number'? Math.max(0,Math.min(pageNeighbours,2)):0;
    let totalPages=Math.ceil(totalRecords/pageLimit);

    const paginationData={
      currentPage:1,
      totalPages:totalPages,
      pageLimit:pageLimit,
      totalRecords:totalRecords,
      pageNeighbours:pageNeighbours
    };

    this.state={rangeOfPages:[],pagData:paginationData};
  }

  componentDidMount(){
    this.setState({rangeOfPages:this.fetchPageNumbers()},()=>this.gotoPage(1));
  }


  componentDidUpdate(prevProps) {
    if (this.props.totalRecords!== prevProps.totalRecords||this.props.selectedAn!==prevProps.selectedAn) {
      const paginationD={
        currentPage:this.state.pagData.currentPage,
        totalPages:Math.ceil(this.props.totalRecords/this.state.pagData.pageLimit),
        pageLimit:this.state.pagData.pageLimit,
        totalRecords:this.props.totalRecords,
        pageNeighbours:this.state.pagData.pageNeighbours
      };
      
      this.setState({pagData:paginationD},()=>this.setState({rangeOfPages:this.fetchPageNumbers()},()=>this.gotoPage(1)));
    }
  }

  gotoPage =page =>{
    const {onPageChanged =f=>f}=this.props;
    const pageCurrent=Math.max(0,Math.min(page,this.state.pagData.totalPages));
    const paginationData={
      currentPage:pageCurrent,
      totalPages:this.state.pagData.totalPages,
      pageLimit:this.state.pagData.pageLimit,
      totalRecords:this.state.pagData.totalRecords,
      pageNeighbours:this.state.pagData.pageNeighbours
    };
    this.setState({pagData:paginationData},
      ()=>this.setState({rangeOfPages:this.fetchPageNumbers()},
      ()=>this.setState({currentPage:pageCurrent},()=>onPageChanged(paginationData)))
    );
    
  }

  handleClick = page => evt => {
    evt.preventDefault();
    this.gotoPage(page);
  }

  handleMoveLeft = evt => {
    evt.preventDefault();
    this.gotoPage(this.state.currentPage - (this.state.pagData.pageNeighbours * 2) - 1);
  }

  handleMoveRight = evt => {
    evt.preventDefault();
    this.gotoPage(this.state.currentPage + (this.state.pagData.pageNeighbours * 2) + 1);
  }

  fetchPageNumbers = () => {


    const totalPages = this.state.pagData.totalPages;
    const currentPage = this.state.pagData.currentPage;
    const pageNeighbours = this.state.pagData.pageNeighbours;

    /**
     * totalNumbers: the total page numbers to show on the control
     * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
     */
    const totalNumbers = (pageNeighbours * 2) + 3;
    const totalBlocks = totalNumbers + 2;

        

    if (totalPages > totalBlocks) {

      const startPage = Math.max(2, currentPage - pageNeighbours);
      
      const endPage = Math.min(totalPages - 1, currentPage + pageNeighbours);

      let pages = range(startPage, endPage);
      /**
       * hasLeftSpill: has hidden pages to the left
       * hasRightSpill: has hidden pages to the right
       * spillOffset: number of hidden pages either to the left or to the right
       */
      const hasLeftSpill = startPage > 2;
      const hasRightSpill = (totalPages - endPage) > 1;
      const spillOffset = totalNumbers - (pages.length + 1);

      switch (true) {
        // handle: (1) < {5 6} [7] {8 9} (10)
        case (hasLeftSpill && !hasRightSpill): {
          const extraPages = range(startPage - spillOffset, startPage - 1);
          pages = [LEFT_PAGE, ...extraPages, ...pages];
          break;
        }

        // handle: (1) {2 3} [4] {5 6} > (10)
        case (!hasLeftSpill && hasRightSpill): {
          const extraPages = range(endPage + 1, endPage + spillOffset);
          pages = [...pages, ...extraPages, RIGHT_PAGE];
          break;
        }

        // handle: (1) < {4 5} [6] {7 8} > (10)
        case (hasLeftSpill && hasRightSpill):
        default: {
          pages = [LEFT_PAGE, ...pages, RIGHT_PAGE];
          break;
        }
      }

      return [1, ...pages, totalPages];

    }
    
     
    return range(1, totalPages);

  }

  
  render() {
  
    if (!this.state.pagData.totalRecords || this.state.pagData.totalPages === 1) return null;
  
    const { currentPage } = this.state.pagData;
    /*const pages = this.fetchPageNumbers();*/
    return (
      <Fragment>
        <nav aria-label="Declaratii Pagination">
          <ul className="pagination">
            { this.state.rangeOfPages.map((page, index) => {
  
              if (page === LEFT_PAGE) return (
                <li key={index} className="page-item">
                  <a className="page-link" href="null" aria-label="Previous" onClick={this.handleMoveLeft}>
                    <span aria-hidden="true">&laquo;</span>
                    <span className="sr-only">Previous</span>
                  </a>
                </li>
              );
  
              if (page === RIGHT_PAGE) return (
                <li key={index} className="page-item">
                  <a className="page-link" href="null" aria-label="Next" onClick={this.handleMoveRight}>
                    <span aria-hidden="true">&raquo;</span>
                    <span className="sr-only">Next</span>
                  </a>
                </li>
              );
  
              return (
                <li key={index} className={`page-item${ currentPage === page ? ' active' : ''}`}>
                  <a className="page-link" href="null" onClick={ this.handleClick(page) }>{ page }</a>
                </li>
              );
  
            }) }
  
          </ul>
        </nav>
      </Fragment>
    );
  
  }

}


Pagination.propTypes = {
totalRecords: PropTypes.number.isRequired,
pageLimit: PropTypes.number,
pageNeighbours: PropTypes.number,
onPageChanged: PropTypes.func
};

export default Pagination;